//menu hover image appen to right side
var imgRenderDiv = document.querySelectorAll('#image_render_div');
var updateImg = (e) => {
    var imgTemplate = '<img src='+e.getAttribute('data-src')+'>';    
    imgRenderDiv.forEach(item =>{
        item.innerHTML += imgTemplate;
    });
}

var resetImg =() => {
    imgRenderDiv.forEach(item =>{
        item.innerHTML = '';
    });
}